export type OverlapInheritValue = 'inherit' | 'block' | 'warn' | 'allow';

export interface AppointmentTypePolicyForm {
  dentistOverlap: OverlapInheritValue;
  chairOverlap: OverlapInheritValue;
}

export const EMPTY_APPOINTMENT_TYPE_POLICY_FORM: AppointmentTypePolicyForm = {
  dentistOverlap: 'inherit',
  chairOverlap: 'inherit',
};

export interface AppointmentTypeBookingPolicyOverrideSparse {
  overlap?: {
    dentist?: 'block' | 'warn' | 'allow';
    chair?: 'block' | 'warn' | 'allow';
  };
}

export const mapOverrideToPolicyForm = (
  override?: AppointmentTypeBookingPolicyOverrideSparse | null
): AppointmentTypePolicyForm => ({
  dentistOverlap: override?.overlap?.dentist ?? 'inherit',
  chairOverlap: override?.overlap?.chair ?? 'inherit',
});

/**
 * Returns sparse override, or null when both fields inherit (clear override).
 */
export const mapPolicyFormToOverride = (
  form: AppointmentTypePolicyForm
): AppointmentTypeBookingPolicyOverrideSparse | null => {
  const overlap: NonNullable<AppointmentTypeBookingPolicyOverrideSparse['overlap']> = {};
  if (form.dentistOverlap !== 'inherit') {
    overlap.dentist = form.dentistOverlap;
  }
  if (form.chairOverlap !== 'inherit') {
    overlap.chair = form.chairOverlap;
  }
  if (Object.keys(overlap).length === 0) {
    return null;
  }
  return { overlap };
};
